import Sections from '@/classes/procedures/Sections'

export default class Step {
  constructor ({ name = null, attributes = {}, sections } = {}) {
    this.name = name
    this.attributes = attributes
    this.sections = new Sections(sections)
  }
}
